// src/components/InsightsView.js
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import InsightsEngine from './InsightsEngine'; // Assuming correct path


const InsightsView = () => {
    // Get apiService and clientId from the parent route context
    const { apiService, clientId } = useOutletContext();

    return (
        <>
            <h2 className="text-xl font-semibold mb-6">AI-Generated Insights</h2>
            {/* Pass the necessary props to the InsightsEngine */}
            {apiService && clientId ? (
                <InsightsEngine clientId={clientId} apiService={apiService} />
            ) : (
                <p className="text-center py-10">Loading insights engine...</p> // Placeholder if context isn't ready
            )}
        </>
    );
};

export default InsightsView;